import * as Yup from "yup";
export default Yup.object({
  title: Yup.string().required("Chapter title is required"),
  description: Yup.string().required("Chapter description is required"),
});
